exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Words-module__words___34jTW{padding:1.25rem 1.75rem}.Words-module__words___34jTW .Words-module__word___TjuZe{padding:0 .35rem;font-size:52px;font-weight:600;cursor:pointer;position:relative;z-index:0}.Words-module__words___34jTW .Words-module__word___TjuZe span{border-radius:2px}.Words-module__words___34jTW .Words-module__word___TjuZe .Words-module__block___25fI-{position:absolute;top:0;left:1px;width:calc(100% - 2px);height:100%;border-radius:8px;background-color:#cfe1fa;z-index:-1}", ""]);

// exports
exports.locals = {
	"words": "Words-module__words___34jTW",
	"word": "Words-module__word___TjuZe",
	"block": "Words-module__block___25fI-"
};